var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompaniesTable',{attrs:{"showSyncButton":true,"tableName":_vm.$t('salesPartnershipsLabel'),"parentCompanyId":0,"canModify":true,"canAddNew":false}})}
var staticRenderFns = []

export { render, staticRenderFns }